import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, PASS_RULES } from "@/lib/api";
import { NativeSelect, Spinner } from "@/components/Brand";
import { PageTitle } from "@/pages/admin/AdminLayout";
import { Input } from "@/components/ui/input";

const SubjectRow = ({ s, onSaved }) => {
  const [v, setV] = useState(s.passing_grade ?? "");
  const save = async () => {
    try {
      await api.patch(`/admin/subjects/${s.id}`, v === "" ? { clear_passing_grade: true } : { passing_grade: Number(v) });
      toast.success(`Passing grade ${s.name} disimpan`);
      onSaved();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <tr className="border-t">
      <td className="px-4 py-2 font-semibold">{s.code && <span className="mr-1 text-amber-700">{s.code}</span>}{s.name}</td>
      <td><Input type="number" step="any" className="w-32" placeholder="tidak ada" value={v} onChange={(e) => setV(e.target.value)} data-testid={`pg-subject-${s.id}`} /></td>
      <td className="pr-4 text-right"><button onClick={save} className="rounded bg-[#0A192F] px-3 py-1.5 text-xs font-semibold text-white" data-testid={`pg-subject-save-${s.id}`}>Simpan</button></td>
    </tr>
  );
};

const PackageRow = ({ p }) => {
  const [rule, setRule] = useState(p.pass_rule);
  const [tpg, setTpg] = useState(p.total_passing_grade ?? "");
  const save = async () => {
    try {
      await api.patch(`/admin/packages/${p.id}`, { pass_rule: rule, total_passing_grade: tpg === "" ? undefined : Number(tpg) });
      toast.success(`Aturan ${p.name} disimpan`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <tr className="border-t">
      <td className="px-4 py-2 font-semibold">{p.name}<div className="text-xs font-normal text-slate-500">{p.category_name}</div></td>
      <td><NativeSelect value={rule} onChange={(e) => setRule(e.target.value)} data-testid={`pg-package-rule-${p.id}`}>{Object.entries(PASS_RULES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</NativeSelect></td>
      <td><Input type="number" step="any" className="w-28" value={tpg} onChange={(e) => setTpg(e.target.value)} data-testid={`pg-package-total-${p.id}`} /></td>
      <td className="pr-4 text-right"><button onClick={save} className="rounded bg-[#0A192F] px-3 py-1.5 text-xs font-semibold text-white" data-testid={`pg-package-save-${p.id}`}>Simpan</button></td>
    </tr>
  );
};

export default function PassingGradeAdmin() {
  const [cats, setCats] = useState([]);
  const [subs, setSubs] = useState(null);
  const [pkgs, setPkgs] = useState([]);
  const load = useCallback(() => {
    Promise.all([api.get("/categories", { params: { all: true } }), api.get("/subjects", { params: { all: true } }), api.get("/admin/packages")])
      .then(([c, s, p]) => { setCats(c.data); setSubs(s.data); setPkgs(p.data); }).catch((e) => toast.error(errMsg(e)));
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  if (!subs) return <Spinner />;
  return (
    <div>
      <PageTitle title="Passing Grade" desc="Atur passing grade per materi (berlaku default) dan aturan kelulusan per paket. Angka awal hanya contoh, bukan ketentuan resmi." />
      <div className="grid gap-6 xl:grid-cols-2">
        <div className="space-y-4">
          {cats.map((c) => (
            <div key={c.id} className="overflow-hidden rounded-xl border bg-white">
              <div className="bg-slate-50 px-4 py-2 text-sm font-bold text-[#0A192F]">{c.name}</div>
              <table className="w-full text-sm"><tbody>{subs.filter((s) => s.category_id === c.id).map((s) => <SubjectRow key={s.id} s={s} onSaved={load} />)}</tbody></table>
            </div>
          ))}
        </div>
        <div className="overflow-x-auto rounded-xl border bg-white self-start">
          <div className="bg-slate-50 px-4 py-2 text-sm font-bold text-[#0A192F]">Aturan kelulusan per paket</div>
          <table className="w-full min-w-[520px] text-sm"><thead className="text-left text-xs uppercase text-slate-500"><tr><th className="px-4 py-2">Paket</th><th>Aturan</th><th>PG total</th><th /></tr></thead>
            <tbody>{pkgs.map((p) => <PackageRow key={p.id} p={p} />)}</tbody></table>
          <p className="p-4 text-xs text-slate-500">Passing grade khusus per materi di dalam paket (mis. berbeda untuk CPNS dan tiap Sekolah Kedinasan) dapat diatur di halaman edit paket.</p>
        </div>
      </div>
    </div>
  );
}
